export const CSB: string = 'csb';
export const FED: string = 'fed';
export const BOB: string = 'bob';
export const SIB: string = 'sib';
export const SBM: string = 'sbm';
export const IDFC: string = 'idfc';
export const IDIB: string = 'idib';
export const CSBIMAGE1LINK =
  'https://www.getonecard.app/assets/apply/CSBCard.png';
export const CSBIMAGE2LINK =
  'https://www.getonecard.app/assets/apply/480x552_1.png';
export const CSBIMAGEMOBILEVIEWLINK =
  'https://www.getonecard.app/assets/apply/CSBCard_981x711.png';
export const BOBIMAGE1LINK =
  'https://www.getonecard.app/assets/apply/BOBCardSingle.png';
export const BOBIMAGE2LINK =
  'https://www.getonecard.app/assets/apply/BOBCard_1.png';
export const BOBIMAGEMOBILEVIEWLINK =
  'https://www.getonecard.app/assets/apply/BOBCard_981x711.png';
export const SBMIMAGE1LINK =
  'https://www.getonecard.app/assets/apply/SBM_Card.png';
export const SBMIMAGE2LINK =
  'https://www.getonecard.app/assets/apply/SBMCard_1.png';
export const SBMIMAGEMOBILEVIEWLINK =
  'https://www.getonecard.app/assets/apply/SBMCard981x711.png';
export const SIBIMAGE1LINK =
  'https://www.getonecard.app/assets/apply/SIB%20Bank.png';
export const SIBIMAGE2LINK =
  'https://www.getonecard.app/assets/apply/SIBCard_1.png';
export const SIBIMAGEMOBILEVIEWLINK =
  'https://www.getonecard.app/assets/apply/SIBCard981x711.png';
export const FEDIMAGE1LINK =
  'https://www.getonecard.app/assets/apply/Federal%20Card.png';
export const FEDIMAGE2LINK =
  'https://www.getonecard.app/assets/apply/FederalCard_1.png';
export const FEDIMAGEMOBILEVIEWLINK =
  'https://www.getonecard.app/assets/apply/FEDERALCard_981x711.png';
export const IDIBIMAGE1LINK =
  'https://getonecard.app/assets/icons/idib_credit_card_image.png';
export const IDIBIMAGEMOBILEVIEWLINK =
  'https://getonecard.app/assets/icons/IndianBank_mobile.png';
export const ALLBANKSIMAGE1LINK =
  'https://www.getonecard.app/assets/apply/480x552pix.png';
export const ALLBANKSIMAGE2LINK =
  'https://www.getonecard.app/assets/apply/480x552pix.png';
export const ALLBANKMOBILEVIEWLINK =
  'https://www.getonecard.app/assets/apply/MetalCreditCard.png';
export const DESKTOPIMAGETYPE1 = 'desktopImageType1';
export const DESKTOPIMAGETYPE2 = 'desktopImageType2';
export const MOBILEVIEWIMAGETYPE = 'mobileViewImage';
